import { Types } from "../actions/advisorTaxFormActions";
import _ from "lodash";

const advisorTaxFormReducers = (state, action) => {
	switch (action.type) {
		case Types.ADVISOR_TAX_FORM_LOAD_REPORTS: {
			let newState = _.cloneDeep(state);

			newState.advisors.taxReports = action.data;

			return newState;
		}
		default:
			return state;
	}
};

export default advisorTaxFormReducers;
